import { createFeatureSelector } from '@ngrx/store';
import { AppState } from '../../core.module';
import { SidebarItem } from './sidebar.reducer';

export namespace SidebarSelectors {
  export const getItems = createFeatureSelector<AppState, SidebarItem[]>(
    'sidebar'
  );
}
